var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":true,"persistent":"","width":"300"}},[_c('v-card',{staticStyle:{"background":"white"},attrs:{"flat":""}},[_c('v-card-text',[_c('animated-logo'),_c('p',[_vm._v("Loading content...")]),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"purple"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }